var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCredentialsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      enableBackground: "new 0 0 491.2 491.2"
    },
    viewBox: "0 0 491.2 491.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M432.6 163.2c-4.2-54.2-49-98-103.2-98-14.6 0-29.2 2.1-41.7 8.3-27.1-44.8-74-73-127.2-73C78.2.6 11.4 68.4 11.4 152.8c0 14.6 2.1 29.2 6.3 43.8C6.2 212.2 0 232 0 251.9c0 53.2 42.7 97 94.9 97h11.5v120.9c0 11.5 9.4 20.9 20.9 20.9h217.9c10.4 0 19.8-9.4 20.9-20.9V349.9h29.2c52.1 0 94.9-43.8 95.9-97-.2-39.6-24.2-75.1-58.6-89.7zM324.2 449.9H148V321.7h176.2v128.2zM190.8 280v-44.8c0-25 19.8-44.8 44.8-44.8s44.8 20.9 44.8 44.8V280h-89.6zm204.3 28.2h-29.2v-7.3c0-11.5-9.4-20.9-20.9-20.9h-24v-44.8c0-46.9-38.6-85.5-85.5-85.5S150 188.3 150 235.2V280h-22.9c-11.5 0-20.9 9.4-20.9 20.9v6.3H93.7c-30.2 0-54.2-25-54.2-56.3 0-14.6 5.2-28.1 14.6-38.6 5.2-5.2 7.3-13.6 4.2-20.9-5.2-12.5-7.3-27.1-7.3-40.7 0-61.5 49-111.6 108.4-111.6 43.8 0 83.4 27.1 100.1 68.8 2.9 10.3 18.7 19.3 31.3 9.4 11.5-8.3 24-12.5 37.5-12.5 34.4 0 62.7 29.2 62.6 64.6-.1 17.6 2.8 23.3 15.6 27.1 25 6.3 42.7 29.2 42.7 55.3.1 31.3-23.9 56.4-54.1 56.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M235.6 434.3c11.5 0 20.9-9.4 20.9-20.9v-28.1c0-11.5-9.4-20.9-20.9-20.9s-20.9 9.4-20.9 20.9v28.1c0 11.5 9.4 20.9 20.9 20.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCredentialsIcon);
export default __webpack_public_path__ + "static/media/credentials-icon.dcea0da8e39f91fadbc2e664cdc93e2f.svg";
export { ForwardRef as ReactComponent };